import { useNavigate } from "react-router-dom"
import { Box, MenuItem } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { getEditNewsRoute } from "../../../../../constants/routes"
import { HoverActionMenu } from "../../../../../shared/components/table/HoverActionMenu"
import { MerchantNewsArticle } from "../merchantNewsItemType"

const useStyles = makeStyles()(() => ({
    wrapper: {
        paddingLeft: "1rem",
    },
}))

type CardDropdownMenuProps = Readonly<{
    article: MerchantNewsArticle
    setShowDeleteModal: React.Dispatch<React.SetStateAction<boolean>>
}>

export const CardDropdownMenu = ({ article, setShowDeleteModal }: CardDropdownMenuProps) => {
    const { classes } = useStyles()
    const navigate = useNavigate()

    return (
        <Box className={classes.wrapper}>
            <HoverActionMenu onOpen={(e) => e.stopPropagation()}>
                {(closeMenu) => [
                    <LocalizedStrict key="edit" id="news-edit">
                        <MenuItem
                            onClick={(e) => {
                                e.stopPropagation()
                                closeMenu()
                                navigate(getEditNewsRoute(article.id))
                            }}
                        >
                            Edit
                        </MenuItem>
                    </LocalizedStrict>,
                    <LocalizedStrict key="delete" id="news-delete">
                        <MenuItem
                            onClick={(e) => {
                                e.stopPropagation()
                                closeMenu()
                                setShowDeleteModal(true)
                            }}
                        >
                            Delete
                        </MenuItem>
                    </LocalizedStrict>,
                ]}
            </HoverActionMenu>
        </Box>
    )
}

